exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-box[data-v-71d45262] .el-form-item__label {\n  text-align: left !important;\n}\n.feedback-box[data-v-71d45262] .el-form-item {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: normal !important;\n      -ms-flex-direction: column !important;\n          flex-direction: column !important;\n}\n[data-v-71d45262] .el-input__inner {\n  height: 40px;\n  line-height: 40px;\n}\n[data-v-71d45262] .el-upload--picture-card {\n  width: 30%;\n}", ""]);

// exports
